import {HiOutlineMenu} from 'react-icons/hi'
import {AiFillCloseCircle} from 'react-icons/ai'
import {BsMoon, BsSun} from 'react-icons/bs'

import Cookies from 'js-cookie'
import {Component} from 'react'
import {Link, withRouter} from 'react-router-dom'
import Container from './StyledComponents'

import ThemeContext from '../../Context/ThemeContext'

import './index.css'

class Navbar extends Component {
  state = {isMenuShown: false}

  onClickMenu = () => {
    this.setState({isMenuShown: true})
  }

  onClickClose = () => {
    this.setState({isMenuShown: false})
  }

  onClickLogout = () => {
    Cookies.remove('jwt_token')
    const {history} = this.props
    history.replace('/login')
  }

  renderMenu = (theme, toggleTheme) => {
    const closeColor = theme ? '#fefefe' : '#111111'
    const sunMoon = theme ? (
      <BsSun color="#fefefe" />
    ) : (
      <BsMoon color="#111111" />
    )
    const onChangeTheme = () => {
      toggleTheme()
    }
    return (
      <Container isDark={theme} className="menu-container">
        <button onClick={onChangeTheme} className="theme-btn" type="button">
          {sunMoon}
        </button>
        <Link to="/" className="link">
          <p className="nav-home-text">Home</p>
        </Link>
        <Link to="/shelf" className="link">
          <p className="nav-bookshelves-text">Bookshelves</p>
        </Link>
        <button
          onClick={this.onClickLogout}
          className="nav-logout-btn"
          type="button"
        >
          Logout
        </button>
        <button
          onClick={this.onClickClose}
          type="button"
          className="nav-close-btn"
        >
          <AiFillCloseCircle color={closeColor} height={20} width={20} />
        </button>
      </Container>
    )
  }

  render() {
    const {isMenuShown} = this.state
    return (
      <>
        <ThemeContext.Consumer>
          {value => {
            const {theme, toggleTheme} = value
            const sunMoon = theme ? (
              <BsSun color="#fefefe" />
            ) : (
              <BsMoon color="#111111" />
            )
            const onChangeTheme = () => {
              toggleTheme()
            }
            return (
              <>
                <Container isDark={theme} className="nav-container">
                  <img
                    src="https://res.cloudinary.com/sunil-bookhub/image/upload/v1687139613/Group_7731bookhub-logo_kx1rkf.png"
                    alt="app logo"
                    className="nav-logo"
                  />
                  <div className="menu-btn">
                    <button
                      onClick={this.onClickMenu}
                      type="button"
                      className="nav-menu-btn"
                    >
                      <HiOutlineMenu color="#475569" size={24} />
                    </button>
                  </div>
                  <div className="nav-text-container">
                    <button
                      onClick={onChangeTheme}
                      className="theme-btn"
                      type="button"
                    >
                      {sunMoon}
                    </button>
                    <Link to="/" className="link">
                      <p className="nav-home-text">Home</p>
                    </Link>
                    <Link to="/shelf" className="link">
                      <p className="nav-bookshelves-text">Bookshelves</p>
                    </Link>
                    <button
                      onClick={this.onClickLogout}
                      className="nav-logout-btn"
                      type="button"
                    >
                      Logout
                    </button>
                  </div>
                </Container>
                {isMenuShown && this.renderMenu(theme, toggleTheme)}
              </>
            )
          }}
        </ThemeContext.Consumer>
      </>
    )
  }
}
export default withRouter(Navbar)
